import { Link } from "react-router";
import { all_routes } from "../../../router/all_routes";

interface Props {
    activeTab:  'FeatureControl';
}

const SettingsMenu = ({activeTab}:Props) => {
    const routes = all_routes;


    return (
        <>
            <Link
                to={routes.featureControl}
                className={`d-inline-flex align-items-center rounded py-2 px-3 ${activeTab === 'FeatureControl' ? 'active' : ''}`}
            >
                <i className="ti ti-arrow-badge-right me-2" />
                Feature Control
            </Link>
        </>
    )
}

export default SettingsMenu;